import { PartnerDetailsPageRoot } from "./PartnerDetailsPage.styles";
import { PartnerDto } from "common/models";
import PartnerDetails from "ui/partners/components/PartnerDetails/PartnerDetails";
import useLocationState from "ui/router/hooks/useLocationState";

function PartnerDetailsPage() {
    const partner = useLocationState<PartnerDto>("partner");
    return (
        <PartnerDetailsPageRoot>
            <PartnerDetails partner={partner as PartnerDto} />
        </PartnerDetailsPageRoot>
    );
}

export default PartnerDetailsPage;
